export const CMS_PAGES = 'CMS_PAGES'

export const ERROR_STATE = 'ERROR_STATE'
